<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col cols="6">
      <v-row align="center">
        <v-switch
          v-model="value"
          :disabled="disabled"
          inset
          class="mt-0 no-input-details pa-0"
          :data-cy="`plugin-switcher-${plugin.id}`"
          @change="setPluginSelection"
        />
      </v-row>
    </v-col>
    <v-col
      cols="6"
      class="text-right"
    >
      {{ plugin.price }}
    </v-col>
  </v-row>
</template>

<script>

export default {
  props: {
    plugin: {
      type: Object,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: this.checked
    }
  },
  watch: {
    checked (val, oldVal) {
      if (val !== oldVal) {
        this.value = this.checked
      }
    }
  },
  methods: {
    setPluginSelection: function (checked) {
      this.$emit('plugin-change', { plugin: this.plugin, checked })
    }
  }
}
</script>
